<template>
<div>
    <label
        class="btn btn-secondary w-100 d-flex"
        :for="id_computed"
        @click="toggleExpanded"
    >
        <svg-image
            class="col-4"
            svg_name="comment"
            color="primary"
        />
        <span class="col-4 text-center">{{ label_computed }}</span>
    </label>

    <form-question-free-text
        v-if="is_expanded"
        :id="id_computed"
        :question="question"
        :request_form="request_form"
        :required="required"
        placeholder="Please type your other answer"
        @update-value="(id, value) => updateValue(value)"
    />
</div>
</template>

<script>
import FormQuestionFreeText from "./FormQuestionFreeText.vue";

export default {
    name: "FormQuestionComment",
    components: {
        FormQuestionFreeText,
    },
    props: {
        id: {
            type: String,
            required: false,
        },
        question: {
            type: Object,
            required: false,
        },
        request_form: {
            type: Object,
            required: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
            required: false,
        },
        expanded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            is_expanded: false,
        }
    },
    computed: {
        id_computed() {
            return this.id ?? this.question.local_id + '.comment';
        },
        label_computed() {
            return this.label ?? `Add comment ${this.required ? '(required)' : '(optional)'}`;
        },
    },
    mounted() {
        this.is_expanded = this.expanded;
    },
    methods: {
        toggleExpanded() {
            this.is_expanded = !this.is_expanded;
        },
        updateValue(value) {
            this.$emit('update-value', this.id_computed, value);
        },
    },
}
</script>
